// Real photo/role for the one team member we can currently confirm (see
// Impressum: "Geschäftsführer: Nils Jäkel") — first name only on the
// tiles. `photo` is the default portrait, `hoverPhoto` swaps in on hover
// (a LARP-costume shot). Maria/Benjamin/Jonas/Tobias use generic class-icon
// art instead of real photos — real photos still pending, but their roles
// are now confirmed.
export const TEAM = {
  de: [
    { name: "Nils", role: "Geschäftsführer", photo: "/assets/brand/nja_01.png", hoverPhoto: "/assets/brand/nja_02.png" },
    { name: "Maria", role: "Gewandung & Requisiten", photo: "/assets/brand/Female Orc_red circle.png", hoverPhoto: null },
    { name: "Benjamin", role: "Spielwelt & Plot", photo: "/assets/brand/Male Elf_red circle.png", hoverPhoto: null },
    { name: "Jonas", role: "Bau & Requisiten", photo: "/assets/brand/Male Elf_red circle.png", hoverPhoto: null },
    { name: "Tobias", role: "Jugendarbeit", photo: "/assets/brand/Male Elf_red circle.png", hoverPhoto: null },
  ],
  en: [
    { name: "Nils", role: "Managing Director", photo: "/assets/brand/nja_01.png", hoverPhoto: "/assets/brand/nja_02.png" },
    { name: "Maria", role: "Costumes & Props", photo: "/assets/brand/Female Orc_red circle.png", hoverPhoto: null },
    { name: "Benjamin", role: "Game World & Plot", photo: "/assets/brand/Male Elf_red circle.png", hoverPhoto: null },
    { name: "Jonas", role: "Construction & Props", photo: "/assets/brand/Male Elf_red circle.png", hoverPhoto: null },
    { name: "Tobias", role: "Youth Work", photo: "/assets/brand/Male Elf_red circle.png", hoverPhoto: null },
  ],
};
